import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import FixedTooltipPortal from 'dpl/common/tooltip/components/FixedTooltipPortal';
import useAnalyticsContext from 'dpl/puppy_search_results/hooks/useAnalyticsContext';
import Icon from 'dpl/common/components/Icon';

import MobileFilterButtons from './MobileFilterButtons';

const CLOSE_ICON_SIZE = '32px';

export default function ExposedFilterBottomModal({
  isFilterMenuOpen,
  setIsFilterMenuOpen,
  resultsType,
  totalItemCount,
  title,
  children
}) {
  const { sendBreedSearchedAnalytics } = useAnalyticsContext();

  function handleCloseClick() {
    setIsFilterMenuOpen(false);
    sendBreedSearchedAnalytics();
  }

  return (
    <FixedTooltipPortal
      isVisible={isFilterMenuOpen}
      onCloseClick={handleCloseClick}
      className="relative"
      wrapperClassName={classnames('flex flex-column justify-end', {
        'top-1': isFilterMenuOpen
      })}
      style={{ paddingBottom: 0, maxHeight: '100%' }}
      shouldHideCloseButton
    >
      <p
        className="font-20 font-serif fw-medium pt3 pb5 dib"
        style={{ maxWidth: `calc(100% - (${CLOSE_ICON_SIZE} + 16px))` }}
      >
        {title}
      </p>
      <button
        type="button"
        onClick={handleCloseClick}
        className="sticky top-0 right-0 fr black-50 z-999 mt2"
        data-test-id="close-button"
      >
        <Icon
          name="close"
          className="ph2 pv2 ba b--light-gray br-100 bg-white"
          height={CLOSE_ICON_SIZE}
          width={CLOSE_ICON_SIZE}
        />
      </button>
      <hr className="b--solid b--default bt-0 mb6" />
      {children}
      <MobileFilterButtons
        className="sticky bottom-0 bg-white pv6"
        setIsMenuOpen={() => setIsFilterMenuOpen(false)}
        totalItemCount={totalItemCount}
        resultsType={resultsType}
      />
    </FixedTooltipPortal>
  );
}

ExposedFilterBottomModal.propTypes = {
  isFilterMenuOpen: PropTypes.bool.isRequired,
  setIsFilterMenuOpen: PropTypes.func.isRequired,
  resultsType: PropTypes.string.isRequired,
  totalItemCount: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};
